// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CustomController from "./custom_controller"
application.register("custom", CustomController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HideDependentController from "./hide_dependent_controller"
application.register("hide-dependent", HideDependentController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PriceController from "./price_controller"
application.register("price", PriceController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SubtotalController from "./subtotal_controller"
application.register("subtotal", SubtotalController)
